 document.addEventListener('DOMContentLoaded',function(){

  var collectionbtns = document.querySelectorAll('.collection-button');
  var collectionps = document.querySelectorAll('.collection-product');

  for(let i=0;i<collectionbtns.length;i++){
    collectionbtns[i].index=i;
    collectionbtns[i].addEventListener('click',function(){
      for(let k=0;k<collectionbtns.length;k++){
        collectionbtns[k].className='collection-button';
      }
      this.className="collection-button collection-choice";
      for (let j=0;j<collectionps.length;j++){
        collectionps[j].className="collection-product";
      }
      collectionps[this.index].className="collection-product product-active";
    })
  }
})